export class User{
  userId:string;
  role: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address: string;
  dwollaCustomerId: string;
  isDwollaCustomer: boolean;
  ssn: any;
  dateOfBirth: any;
  isBusiness: boolean;
  taxId: string;
  companyType: string;
}
